// client/src/lib/supabaseBrowser.js
import { createClient } from '@supabase/supabase-js';

const url  = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anon) {
  console.error('[Supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY');
}

const supabase =
  window.__beemSupabase ??
  createClient(url, anon, {
    auth: {
      storageKey: 'beem-auth',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  });

window.__beemSupabase = supabase;

export default supabase;
